module.exports = __webpack_public_path__ + "static/media/1.29f7be1b.jpg";